import { Component, OnInit, ViewContainerRef, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { debounceTime, map, take } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Onboarding, OnbValidators, Status, LeadSource } from '../../../models/onboarding';
import { ApiService } from '../../../services/api.service';
import { ModalDialogService } from 'ngx-modal-dialog';
import { AlgCfModalComponent } from '../../dialogs/alg-cf-modal/alg-cf-modal.component';
import { CustomValidators } from 'ng2-validation';
import { AlgPrivacyModalComponent } from '../../dialogs/alg-privacy-modal/alg-privacy-modal.component';
import { Privacy } from '../../../models/privacy';
import { UtilsService } from '../../../services/utils.service';
import { AlgPrivacyService } from '../../../services/alg-privacy.service';
import { AlgGtmService } from '../../../services/alg-gtm.service';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { AlgEmailModalComponent } from '../../dialogs/alg-email-modal/alg-email-modal.component';
import { ActivatedRoute } from '@angular/router';
import { TranslationService } from 'angular-l10n';

const privacyData = require('../../../data/newPrivacy.json');

@Component({
  selector: 'alg-user-info',
  templateUrl: './alg-user-info.component.html',
  styleUrls: ['./alg-user-info.component.scss'],
})
export class AlgUserInfoComponent implements OnInit {
  public userInfoForm: FormGroup;
  public readAcceptances = { privacy: false };
  public variablesPrivacyCondition = { privacy: false };
  public onboarding: Onboarding;
  public informativeNoteUrl$: Observable<string>;
  public isCfVisible = false;
  public prefixes = [{ label: '+39', value: '+39' }];
  public powerValue: any;
  public privacyItems: any = null;
  public informativeNoteUrlNew = 'https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/07-luglio/ACCENDI-privacy/Nota-informativa-PRIVACY.pdf';
  public emailErrorMessage = 'EMAIL_REQUIRED';
  public changeUrl: boolean = false;
  public showEmailInfo: boolean = false;
  public checkboxClass: boolean = false;
  @Output() statusBack = new EventEmitter<string>();

  private privacyFieldsMap = {
    commercialiALG: 'privacyComCom',
    profilazioneALG: 'privacyProf',
    qualità: 'privacyQualServ',
    commercialiTerzi: 'privacyComTer',
    profilazioneTerzi: 'privacyProfTer',
  };

  public prefixPreFill: string;
  public privacyMapper = {
    privacyComCom: false,
    privacyProf: false,
    privacyQualServ: false,
    privacyComTer: false,
    privacyProfTer: false,
  };

  constructor(
    private api: ApiService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private privacySerice: AlgPrivacyService,
    private gtm: AlgGtmService,
    private el: ElementRef,
    private route: ActivatedRoute,
    private translation: TranslationService
  ) {
    this.informativeNoteUrl$ = this.privacySerice.onbPrivacyUrl$.pipe(map((urls) => urls.informativeNote));
  }

  ngOnInit() {
    this.api.currentOnboarding.combineLatest(this.api.currentProduct).subscribe(([onboarding, product]) => {
      if (onboarding.product) {
        this.powerValue = onboarding.product.type;
      }
      if (product.family && product.family.differentAddress) {
        onboarding.differentForniture = true;
      }
      if (product.family && product.family.postaDisabled !== false) {
        this.showEmailInfo = false;
      } else {
        this.showEmailInfo = true;
      }
      if (onboarding.phone) this.prefixPreFill = '+39';
      onboarding.prefix = 39;
      this.onboarding = onboarding;
      this.route.params.subscribe((url_params) => {
        if (url_params.secondary) {
          this.onboarding.isDefaultPromo = true;
        }
      });

      if (onboarding._id && !this.changeUrl) {
        history.pushState({ canBeAnything: true }, '', `/?oid=${onboarding.feId}`);
      }
      this.readAcceptances.privacy = onboarding.generalPrivacy;
      this.variablesPrivacyCondition.privacy = onboarding.generalPrivacy;
      this.readPrivacyMapperL();
    });

    this.userInfoForm = new FormGroup({
      firstname: new FormControl(this.onboarding.firstname, {
        validators: [Validators.required],
      }),
      lastname: new FormControl(this.onboarding.lastname, {
        validators: [Validators.required],
      }),
      // cf: new FormControl(this.onboarding.cf, {
      //   validators: [
      //     Validators.required,
      //     OnbValidators.cf,
      //   ]
      // }),
      email: new FormControl(this.onboarding.email, {
        validators: [Validators.required, CustomValidators.email],
      }),
      // prefix: new FormControl(this.onboarding.prefix),
      phone: new FormControl(this.onboarding.phone, {
        validators: [Validators.required, Validators.minLength(5), Validators.maxLength(11)],
      }),
      firstCondition: new FormControl('', {
        validators: [Validators.requiredTrue],
      }),
    });

    this.userInfoForm.valueChanges.subscribe((data) => {
      if (data.firstname && data.lastname) {
        this.isCfVisible = true;
      } else {
        this.isCfVisible = false;
      }
    });

    this.privacyItems = Object.keys(privacyData)
      .filter(
        (key) => ['accendi'].indexOf(key) === -1
        // ['commercialiTerzi', 'profilazioneTerzi', 'accendi'].indexOf(key) === -1
      ) // HACK: removes it to re-eanble last two consents (leave only 'accendi')
      .slice(2)
      .map((e) => {
        privacyData[e].title = privacyData[e].title;
        privacyData[e]['id'] = this.privacyFieldsMap[e];
        privacyData[e]['modalFlag'] = e;
        return privacyData[e];
      });
  }

  public nextStep() {
    this.privacyMapperL();
    this.markFormGroupTouched(this.userInfoForm);
    const invalidControl = this.el.nativeElement.querySelector('form .ng-invalid');
    if (invalidControl) return this.scrollOnInvalidElement(invalidControl);
    if (this.userInfoForm.status === 'VALID' && this.variablesPrivacyCondition.privacy) {
      this.onboarding.generalPrivacy = true;
      this.onboarding.leadSource = LeadSource.drops;
      this.statusBack.emit('current');
      this.api.nextStep(this.onboarding, Status.userInfo);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control.controls) this.markFormGroupTouched(control);
    });
  }

  private scrollOnInvalidElement(invalidControl) {
    this.controlCheckbox();
    window.scroll({
      top: this.getTopOffset(invalidControl),
      left: 0,
      behavior: 'smooth',
    });

    fromEvent(window, 'scroll')
      .pipe(debounceTime(100), take(1))
      .subscribe(() => invalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  changeCheckbox(event, checkbox) {
    switch (checkbox) {
      case 'privacy':
        if (!this.readAcceptances.privacy) {
          // window.open(this.informativeNoteUrlNew)
        }
        this.variablesPrivacyCondition.privacy = !this.variablesPrivacyCondition.privacy;
        this.readAcceptances.privacy = true;
        this.checkboxClass = !this.readAcceptances.privacy;
        break;
    }
  }

  public openCFModal() {
    if (!this.checkIfMobile()) {
      this.gtm.submitOnbEvent('Calcola codice fiscale');
    }
    this.utils.disableOverflow();
    this.api.saveOnboarding(this.onboarding);
    this.modalDialogService.openDialog(this.viewContainer, {
      title: `Compila qua il tuo codice fiscale`,
      childComponent: AlgCfModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: this.onboarding,
    });
  }

  openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgPrivacyModalComponent,
      settings: {
        modalDialogClass: 'modal-dialog-unoverflow',
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: modalContent.description,
        id: modalContent.modalFlag || modalContent.title.replace(/ /g, ''),
      },
    });
  }

  public readPrivacy(type) {
    let modalContent;
    switch (type) {
      case 'commercialiALG':
        modalContent = Privacy('commercialiALG');
        break;
      case 'profilazioneALG':
        modalContent = Privacy('profilazioneALG');
        break;
      case 'commercialiTerzi':
        modalContent = Privacy('commercialiTerzi');
        break;
      case 'profilazioneTerzi':
        modalContent = Privacy('profilazioneTerzi');
        break;
      default:
        modalContent = Privacy('qualità');
    }
    this.openModal(modalContent || {});
  }
  public checkEmail() {
    if (this.onboarding.email.indexOf('@') == -1) return (this.emailErrorMessage = 'EMAIL_MISSING_AT');
    if (this.onboarding.email.split('@')[1].indexOf('.') == -1) return (this.emailErrorMessage = 'EMAIL_MISSING_DOT');
    return;
  }

  private checkIfMobile() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor);
    return check;
  }

  private privacyMapperL() {
    this.onboarding.privacyComCom = this.privacyMapper.privacyComCom ? 'agree' : 'disagree';
    this.onboarding.privacyProf = this.privacyMapper.privacyProf ? 'agree' : 'disagree';
    this.onboarding.privacyQualServ = this.privacyMapper.privacyQualServ ? 'agree' : 'disagree';
    this.onboarding.privacyComTer = this.privacyMapper.privacyComTer ? 'agree' : 'disagree';
    this.onboarding.privacyProfTer = this.privacyMapper.privacyProfTer ? 'agree' : 'disagree';
  }

  private readPrivacyMapperL() {
    this.privacyMapper.privacyComCom = this.onboarding.privacyComCom === 'agree' ? true : false;
    this.privacyMapper.privacyProf = this.onboarding.privacyProf === 'agree' ? true : false;
    this.privacyMapper.privacyQualServ = this.onboarding.privacyQualServ === 'agree' ? true : false;
    this.privacyMapper.privacyComTer = this.onboarding.privacyComTer === 'agree' ? true : false;
    this.privacyMapper.privacyProfTer = this.onboarding.privacyProfTer === 'agree' ? true : false;
  }

  showSecondModal() {
    this.gtm.submitOnbEvent('Visualizzazione modale', 'Perché inserire email');
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: `Perché inserire l’email?`,
      childComponent: AlgEmailModalComponent,
      settings: {
        bodyClass: 'modal-body',
        modalDialogClass: 'modal-dialog',
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
    });
  }

  gtmPush(itemName, value) {
    return this.gtm.submitOnbEvent('Scelta consenso ' + itemName, value ? 'agree' : 'disagree');
  }

  controlCheckbox() {
    if (!this.readAcceptances.privacy) return (this.checkboxClass = true);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/steps/alg-user-info/alg-user-info.component.ts